<template>
  <div class="admin users">
    <AdminHeader />
    <div class="row">
      <div class="col-3">
        <div class="row">
          <div class="col-12 row-header">Users</div>
        </div>
        <div class="scrolling-table" v-show="!loading">
          <template v-for="item in users">
            <div
              class="row clickable"
              :key="item.id"
              v-show="item.active == !show_deleted"
              v-bind:class="{ selected: item == user }"
              @click="_userSelected(item)"
            >
              <div class="col-12">
                {{ item.email }}
              </div>
            </div>
          </template>
        </div>
      </div>
      <div class="col-9">
        <div class="row">
          <UserDetail
            :user="user"
            class="col-12"
            ref="user_detail"
            @new="_new_user"
          />
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-3">
        <input type="checkbox" id="show_deleted" @click="_show_deleted" />
        <label for="show_deleted">Show Deleted</label>
      </div>
    </div>
    <NewUserModal
      ref="new_user_modal"
      v-show="showNewUserModal"
      @close="_closeNewUserModal"
    />
  </div>
</template>

<script>
import AdminHeader from "@/components/admin/AdminHeader.vue";
import UserDetail from "@/components/admin/user/UserDetail.vue";
import NewUserModal from "@/components/admin/user/NewUserModal.vue";
import { mapState, mapActions } from "vuex";

export default {
  name: "Users",
  data: () => ({
    user: null,
    loading: false,
    show_deleted: false,
    showNewUserModal: false,
  }),
  computed: {
    ...mapState("users", ["users", "new_user"]),
  },
  watch: {
    new_user(new_value) {
      this.user = new_value;
      this.$refs.new_user_modal.clear();
    },
  },
  methods: {
    ...mapActions("users", ["apiSaveUser", "apiCreateUser"]),
    _show_deleted() {
      this.show_deleted = !this.show_deleted;
    },
    _new_user() {
      this.showNewUserModal = true;
    },
    _closeNewUserModal() {
      this.showNewUserModal = false;
    },
    _userSelected(user) {
      this.user = user;
    },
    _delete_user() {
      if (this.user != null && this.user.id > 0) {
        this.user.active = !this.user.active;
        this.apiSaveUser(this.user);
      }
    },
  },
  components: {
    AdminHeader,
    UserDetail,
    NewUserModal,
  },
};
</script>
